import { render, staticRenderFns } from "./manage-document-tags-modal.vue?vue&type=template&id=6328bb28"
import script from "./manage-document-tags-modal.vue?vue&type=script&lang=js"
export * from "./manage-document-tags-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports